import { MantineTheme, rem } from "@mantine/core";
import { rgba } from "polished";

import { ThemeComponent } from "./helpers.ts";

const basicButton = {
  icon: {
    width: `${rem(24)}`,
    height: `${rem(24)}`,
    minHeight: "unset",
    minWidth: "unset",
  },
  gap: rem(12),
  height: rem(44),
  fontWeight: 600,
  lineHeight: 1.5,
  borderRadius: rem(4),
  padding: ` ${rem(8)} ${rem(20)}`,
  width: "fit-content",
};

const basicFilledButton = (theme: MantineTheme, backgroundColor: string) => ({
  root: {
    ...basicButton,
    color: theme.colors.white[0],
    backgroundColor: backgroundColor,
    "&:hover": {
      opacity: 0.9,
    },
    "&:focus": {
      background: backgroundColor,
      color: theme.colors.white[0],
    },
    "&:disabled": {
      color: theme.colors.white[0],
      background: theme.colors.grayIce[0],
    },
  },
});

const blueFilledButton = (theme: MantineTheme) =>
  basicFilledButton(theme, theme.colors.dusk[0]);

const goldenFilledButton = (theme: MantineTheme) =>
  basicFilledButton(theme, theme.colors.golden[0]);

const blueOutlineButton = (theme: MantineTheme) => ({
  root: {
    ...basicButton,
    color: theme.colors.dusk[0],
    background: "transparent",
    border: `1px solid ${theme.colors.dusk[0]}`,
    "&:hover": {
      background: rgba(theme.colors.dusk[0], 0.1),
    },
    "&:focus": {
      background: rgba(theme.colors.dusk[0], 0.1),
    },
    "&:focus:not(:focus-visible)": {
      background: "transparent",
    },
    "&:disabled": {
      color: theme.colors.grayIce[0],
      border: `1px solid ${theme.colors.grayIce[0]}`,
    },
  },
});

const goldenOutlineButton = (theme: MantineTheme) => ({
  root: {
    ...basicButton,
    color: theme.colors.golden[0],
    background: theme.colors.white[0],
    border: `1px solid ${theme.colors.golden[0]}`,
    "&:hover": {
      background: rgba(theme.colors.golden[0], 0.1),
    },
    "&:focus:not(:focus-visible)": {
      background: "transparent",
    },
    "&:disabled": {
      color: theme.colors.grayIce[0],
      border: `1px solid ${theme.colors.grayIce[0]}`,
    },
  },
});
export default function buttonTheme(): ThemeComponent {
  return {
    variants: {
      filledBlue: blueFilledButton,
      filledGolden: goldenFilledButton,
      outlineBlue: blueOutlineButton,
      outlineGolden: goldenOutlineButton,
    },
    sizes: {
      s: () => ({
        root: {
          height: rem(32),
          fontSize: rem(12),
        },
      }),
    },
  };
}
